const isElementIsBody = el => el === document.body

const getElementClientRect = el => el.getBoundingClientRect()

export const httpRequest = async (resource, options) => {
    const { timeout = 30000 } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(resource, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id);

    if (!response.ok) {
        throw new Error('Request is failed')
    }

    return response;
}

export const validator = {
    isValue: value => {
        try {
            return value !== void 0 && value !== null
        } catch (err) {
            return false
        }
    },
    isJsonString: value => {
        try {
            return JSON.parse(value) && !!value;
        } catch (err) {
            return false;
        }
    },
    isURL: value => {
        try {
            const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
            return regexp.test(value)
        } catch (err) {
            return false;
        }
    },
    isNumber: value => {
        return typeof value === 'number' && isFinite(value)
    }
}

export const throttle = (func, waitTime) => {
    let isThrottled = false,
        savedArgs,
        savedThis;

    function wrapper() {
        if (isThrottled) {
            savedArgs = arguments;
            savedThis = this;
            return;
        }
        func.apply(this, arguments);
        isThrottled = true;
        setTimeout(function() {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = savedThis = null;
            }
        }, waitTime);
    }

    return wrapper;
}

export const getElementYOffset = el =>
    isElementIsBody(el) ? window.pageYOffset : el.scrollTop

export const getElementInnerHeight = el =>
    isElementIsBody(el) ? window.innerHeight : el.clientHeight

export const getScrollReadyElement = el =>
    isElementIsBody(el) ? window : el

export const getElementPositions = (el, iFrame) => {
    const positions = {
        top: undefined,
        left: undefined,
        height: undefined,
        bottom: undefined,
    }
    const iFrameRect = getElementClientRect(iFrame)
    if (isElementIsBody(el)) {
        positions.top = iFrameRect.top
        positions.left = iFrameRect.left
        positions.height = iFrameRect.height
        positions.bottom = iFrameRect.bottom
    } else {
        positions.top = iFrameRect.top - getElementClientRect(el).top;
        positions.left = el.scrollLeft
        positions.height = el.scrollHeight
        positions.bottom = positions.top + positions.height
    }
    return positions
}

export const getScrollableParent = el => {
    const div = document.createElement('div')
    div.style.height = `${2 * window.innerHeight}px`
    el.appendChild(div)

    const isScrollable = el => {
        const hasScrollableContent = el.scrollHeight > el.clientHeight
        if (!hasScrollableContent) return false

        const overflowYStyle = window.getComputedStyle(el).overflowY
        const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1

        return hasScrollableContent && !isOverflowHidden
    }
    const checkElement = el => {
        return !el || el === document.body
            ? document.body
            : isScrollable(el)
                ? el
                : checkElement(el.parentNode)
    }

    const scrollableParent = checkElement(el)
    while (el.firstChild) {
        el.removeChild(el.lastChild);
    }
    return scrollableParent
}